import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";

import { profileSchema, type ProfileForm } from "../schema/auth.scehma";

interface ProfileStepProps {
  onSuccess: (data: ProfileForm) => void;
  isPending?: boolean;
}

const VOICE_STYLES = [
  {
    value: "maddahi",
    label: "مداحی",
  },
  {
    value: "qeraat",
    label: "قرائت",
  },
  {
    value: "singing",
    label: "خوانندگی",
  },
  {
    value: "narration",
    label: "گویندگی و سخنوری",
  },
  {
    value: "other",
    label: "سایر",
  },
];

export const ProfileStep = ({
  onSuccess,
  isPending = false,
}: ProfileStepProps) => {
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm<ProfileForm>({
    resolver: zodResolver(profileSchema),
    mode: "onChange",
    defaultValues: {
      fullName: "",
      voiceStyle: "",
    },
  });

  const onSubmit = (data: ProfileForm) => {
    onSuccess(data);
  };
  const voiceStyle = watch("voiceStyle");
  return (
    <form onSubmit={handleSubmit(onSubmit)} className="space-y-4.75">
      {/* Full Name */}
      <div>
        <input
          {...register("fullName")}
          type="text"
          autoComplete="name"
          disabled={isPending}
          placeholder="نام و نام خانوادگی"
          className="
            h-14
            w-full
            rounded-xl
            bg-white
            px-4
            text-right
            font-kalameh
            text-button-2
            text-gray-800
            outline-none
            placeholder:text-gray-400
            focus:ring-2
            focus:ring-[#5abcf0]
            disabled:cursor-not-allowed
            disabled:opacity-70
          "
        />

        {errors.fullName && (
          <p className="mt-1.5 px-1 text-right font-kalameh text-sm text-red-500">
            {errors.fullName.message}
          </p>
        )}
      </div>

      {/* Voice Style */}
      <div>
        <select
          {...register("voiceStyle")}
          disabled={isPending}
          className={`
    h-14
    w-full
    appearance-none
    rounded-xl
    bg-white
    px-4
    text-right
    font-kalameh
    text-button-2
    outline-none
    focus:ring-2
    focus:ring-[#5abcf0]
    disabled:cursor-not-allowed
    disabled:opacity-70
    ${voiceStyle ? "text-gray-800" : "text-gray-400"}
  `}
        >
          <option value="" disabled className="font-kalameh text-button-2">
            سبک مورد علاقه صداسازی
          </option>

          {VOICE_STYLES.map((style) => (
            <option
              key={style.value}
              value={style.value}
              className="font-kalameh text-button-2"
            >
              {style.label}
            </option>
          ))}
        </select>

        {errors.voiceStyle && (
          <p className="mt-1.5 px-1 text-right font-kalameh text-sm text-red-500">
            {errors.voiceStyle.message}
          </p>
        )}
      </div>

      {/* Submit */}
      <button
        type="submit"
        disabled={isPending}
        className="
          h-15.5
          w-full
          rounded-xl
          bg-linear-to-l
          from-[#4dbcf0]
          to-[#9b5cff]
          font-kalameh
          text-button-1
          text-white
          transition
          hover:opacity-90
          disabled:cursor-not-allowed
          disabled:opacity-60
        "
      >
        {isPending ? (
          <p>در حال ثبت اطلاعات...</p>
        ) : (
          <div className="flex items-center justify-center gap-3">
            <p>ورود به دنیای صداسازی</p>

            <img
              src="/images/arrow_right.png"
              alt="arrow"
              className="h-5.75 w-5.75"
            />
          </div>
        )}
      </button>
    </form>
  );
};
